import clsx from 'clsx'

export function formatPrice(price) {
  if (price == null || price === '') return ''
  const numeric = Number(String(price).replace(/[^0-9.]/g, ''))
  if (Number.isNaN(numeric)) return ''
  return `$${numeric.toFixed(2)}`
}

export function Price({ price, compareAtPrice, className = 'flex' }) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || 0)
  const formattedPrice = formatPrice(price)
  const formattedCompare = formatPrice(compareAtPrice)

  return (
    <p className={clsx('flex gap-1', className)}>
      <span className="paragraph-sm font-bold text-primary-sale only:text-primary-black">{formattedPrice}</span>
      {!isOnSale || !formattedCompare ? null : (
        <span className="paragraph-sm text-neutrals-tertiary-grey line-through decoration-neutrals-tertiary-grey">
          {formattedCompare}
        </span>
      )}
    </p>
  )
}
